<template>
  <v-app :style="cssVars">
    <vue-headful
      v-if="!!project.name"
      :title="project.name"
    />
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      touchless
    >
      <div class="inner_drawer">
        <v-toolbar class="turquoise" flat>
          <div>
            <img
              v-if="!!projectLogo"
              :src="getCdn(`${projectLogo}?height=40&width=999`)"
            />
            <p class="white--text project_name">{{ project.name }}</p>
          </div>
        </v-toolbar>
        <v-list @click.native="drawer = false">
          <router-link
            v-for="(item, idx) in menuOptions"
            :key="idx"
            :class="[
              { isActive: $route.name.includes(`order.${item.route}`) },
              {'custom-navigation-highlight': shouldBeActive(item)}
            ]"
            :to="{ name: `order.${item.route}`, params: { id: item.id }  }"
            class="v-list__tile"
            flat
            tag="div"
          >
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.label) }}</v-list-item-title>
            </v-list-item-content>
          </router-link>
        </v-list>
        <v-spacer/>
        <div class="trademark">
          <p class="product_name">Navigator™</p>
<!--          <p class="pow_by">-->
<!--            Powered by PIXERYMEDIA-->
<!--          </p>-->
        </div>
      </div>
    </v-navigation-drawer>
    <v-app-bar
      v-if="topmenu"
      app
      class="body-2 text-xs-center"
      fixed
      :height="appBarHeight"
    >
      <img
        v-if="!!projectLogo"
        :src="getCdn(`${projectLogo}?height=40&width=999`)"
        class="hidden-xs-only logo"
      />
      <v-btn
        class="turquoise--text text--lighten-3 hidden-md-and-up" icon
        text
        @click.stop="drawer = !drawer"
      >
        <v-icon>menu</v-icon>
      </v-btn>
      <v-spacer/>
      <v-toolbar-items>
        <slot name="mobileExteriorNavigation"></slot>
        <div v-if="readyPages.length > 1" class="hidden-sm-and-down">
          <router-link
            v-if="haseHomePage"
            :class="{ homeInactive: !$route.name.includes('order.home') }"
            :to="`/${$route.params.order}`"
            class="navigator-tab-item"
            flat
            tag="button"
          >
            <v-icon>home</v-icon>
          </router-link>
          <template
            v-for="(page, i) in readyPages"
            v-if="!!i18nTranslations"
          >
            <router-link
              :key="i"
              :to="{ name: `order.${page.route}`, params: { id: page.id } }"
              class="navigator-tab-item"
              flat
              tag="button"
              :class="{'custom-navigation-highlight': shouldBeActive(page)}"
            >{{ $t(page.label) }}
            </router-link>
          </template>
        </div>
      </v-toolbar-items>

      <v-spacer/>
      <v-toolbar-items>
        <v-btn
          v-if="favourites.length > 0"
          class="hidden-sm-and-down turquoise--text"
          icon
          text
          @click="openedDialogFavouritesDesktop = true"
        >
          <v-badge color="turquoise">
            <template v-slot:badge>
              <span>{{ favourites.length }}</span>
            </template>
            <v-icon class="turquoise--text">favorite_border</v-icon>
          </v-badge>
        </v-btn>
        <v-btn
          v-if="fullscreenEnabled"
          class="hidden-sm-and-down turquoise--text"
          icon
          text
          @click="toggleFullscreen()"
        >
          <v-icon v-if="fullscreen || $fullscreen.getState()">fullscreen_exit</v-icon>
          <v-icon v-else>fullscreen</v-icon>
        </v-btn>
        <v-menu v-model="vMenu" bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="dropdownMenuFulfilled"
              class="turquoise--text"
              :class="isShowTogglePOI? '' : 'hidden-md-and-up'"
              icon
              text
              v-on="on"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="isShowTogglePOI">
              <v-switch
                :input-value="isPoiMaskOn"
                :label="$t('poi_switch')"
                :value="isPoiMaskOn"
                background-color="#fff"
                class="mt-0 pt-0"
                color="turquoise"
                height="56px"
                hide-details
                @change="togglePoiMaskStatus"
              />
            </v-list-item>
            <v-list-item class="hidden-md-and-up" v-if="dropdownMenuState.overlay">
              <v-switch
                :input-value="overlayStatus"
                :label="$t('Overlay_Status')"
                :value="overlayStatus"
                background-color="#fff"
                class="mt-0 pt-0"
                color="turquoise"
                height="56px"
                hide-details
                @change="toggleOverlayStatus"
              />
            </v-list-item>
            <v-list-item
              v-if="dropdownMenuState.favourites"
              @click.stop="openedDialogFavouritesMobile = true; vMenu = false"
            >
              <v-btn class="turquoise--text" icon text>
                <v-badge color="turquoise">
                  <template v-slot:badge>
                    <span>{{ favourites.length }}</span>
                  </template>
                  <v-icon class="turquoise--text">favorite_border</v-icon>
                </v-badge>
              </v-btn>
              <v-list-item-title class="morevert__menu-item">
                {{ $t('Favourites_list') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              class="hidden-md-and-up"
              v-if="dropdownMenuState.fullscreen"
              @click="toggleFullscreen()"
            >
              <v-btn
                class="turquoise--text"
                icon
                text
              >
                <v-icon v-if="fullscreen || $fullscreen.getState()">fullscreen_exit</v-icon>
                <v-icon v-else>fullscreen</v-icon>
              </v-btn>
              <v-list-item-title class="morevert__menu-item"
              >{{ $t('Full_screen') }}
              </v-list-item-title>
            </v-list-item>
            <!--            <v-divider class="hidden-md-and-up hidden-lg-and-down"/>
                        <v-list-item
                          v-if="dropdownMenuState.contact"
                          @click="contactsDialog = true"
                        >
                          <v-list-item-title class="morevert__menu-item">
                            Contact Us
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="dropdownMenuState.about"
                          @click.stop="aboutDialog = true; vMenu = false;"
                        >
                          <v-list-item-title class="morevert__menu-item">
                            about
                          </v-list-item-title>
                        </v-list-item>-->
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-dialog v-model="cookiePolicyDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t('cookie-policy') }}</v-card-title>
        <v-card-text/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="grey darken-2"
            text
            @click="
                            cookiePolicyDialog = false;
                            switchAnalytics(false);
                          "
          >I Disagree
          </v-btn>
          <v-btn
            class="turquoise"
            @click="
                            cookiePolicyDialog = false;
                            switchAnalytics(true);
                          "
          >I Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="aboutDialog" max-width="500">
      <v-card class="about-dialog">
        <v-card-title class="headline">Navigator 7.0</v-card-title>
        <v-card-text>
          {{ $t('About_Dialog_Content') }}
        </v-card-text>
        <v-card-text>
          <a
            class="dialog-link"
            @click="openExternalLink(project.termsOfUse)"
          >
            Disclaimer
          </a>
          <a
            class="dialog-link"
            @click.stop="privacyPolicyDialog = true; vMenu = false;"
          >
            Privacy Policy
          </a>
          <a
            class="dialog-link"
            @click.stop="cookiePolicyDialog = true; vMenu = false;"
          >
            Cookie Policy
          </a>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            class="turquoise"
            text
            @click="aboutDialog = false"
          >close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="privacyPolicyDialog" max-width="750">
      <v-card>
        <v-card-title class="headline">Navigator 7.0</v-card-title>
        <v-card-text/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            class="turquoise"
            text
            @click="privacyPolicyDialog = false"
          >close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unitListDialog" max-width="750">
      <v-card>
        <v-card-title class="headline">Navigator 7.0</v-card-title>
        <v-card-text/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            class="turquoise"
            text
            @click="unitListDialog = false"
          >close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!mobile"
      v-model="contactsDialog"
      :max-width="!contactFormEnabledOnContactPage ? 640 : 1000"
      content-class="contacts_card"
    >
      <ContactsCard
        :agents="agents"
        :brokerCompany="brokerCompany"
        :contactsModules="contactsModules"
        :favouriteUnitsList="favourites"
        :projectSettings="settings"
        class="contacts_card"
      />
    </v-dialog>

    <v-dialog
      v-model="openedDialogFilterMobile"
      content-class="filter_modal hidden-md-and-up"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-toolbar color="turquoise" dark>
        <v-btn dark icon @click="openedDialogFilterMobile = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('Unit_list') }}</v-toolbar-title>
        <v-spacer/>
        <v-btn class="d-none" text>
          <v-icon dark left>replay</v-icon>
          filters
        </v-btn>
      </v-toolbar>
      <FilterModal :closeDialog="() => this.openedDialogFilterMobile = false" mobile="true"/>
    </v-dialog>
    <v-dialog
      v-model="openedDialogFavouritesDesktop"
      content-class="favorite_modal"
      max-width="900"
    >
      <FavouriteModal
        :closeDialog="() => (openedDialogFavouritesDesktop = !openedDialogFavouritesDesktop)"
      />
    </v-dialog>
    <v-dialog
      v-model="openedDialogFavouritesMobile"
      content-class="favorite_modal hidden-md-and-up"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-toolbar color="turquoise" dark>
        <v-btn dark icon @click="openedDialogFavouritesMobile = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('Favourites_list') }}</v-toolbar-title>
      </v-toolbar>
      <FavouriteModal
        :closeDialog="() => (openedDialogFavouritesMobile = !openedDialogFavouritesMobile)"
        mobile="true"
      />
    </v-dialog>

    <button
      v-if="contactAvailable"
      class="v-btn v-btn--floating v-btn--fixed
          hidden-sm-and-down
          turquoise white--text
          toggle-contacts-dialog"
      fab
      type="button"
      @click="contactsDialog = true"
    >
      <div class="v-btn__content">
        <i aria-hidden="true" class="v-icon material-icons">
          local_phone
        </i>
      </div>
    </button>
    <v-content :class="classList" v-tooltip-improver="{ floorplan: { width: 200, height: 250 } }">
      <slot></slot>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import fullscreen from 'vue-fullscreen';
import VueHeadful from 'vue-headful';
import IconSunMoon from '@/components/icons/SunMoon.vue';
import ContactsCard from '@/components/ContactsCard.vue';
import FavouriteModal from '@/components/FavouriteModal.vue';
import PoweredByLogo from '@/components/icons/PoweredByLogo.vue';
import { ADD_FAVOURITE } from '@/store/modules/units/mutation-types';
import { cdnUrl } from '@/utils/urls';
import { ROUTE_UNIT_LIST } from '@/routes/enum';
import TopMenuDisactivator from '@/mixins/TopMenuDisactivator';

const PAGE_EXCLUSIONS = {
  mobile: ['home', 'sunstudyPage'],
  desktop: ['home', 'contact', 'sunstudyPage'],
};

Vue.use(fullscreen);

const APP_BAR_HEIGHT = 56;

export default {
  /**
   * The name of the layout.
   */
  name: 'DefaultLayout',
  components: {
    IconSunMoon,
    PoweredByLogo,
    // UnitListModal,
    FavouriteModal,
    ContactsCard,
    VueHeadful,
  },
  props: {
    classList: {
      type: String,
      required: false,
    },
    overlayStatus: {
      type: Boolean,
      required: false,
    },
    toggleOverlayStatus: {
      type: Function,
      required: false,
    },
    disableContact: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [TopMenuDisactivator],
  /**
   * The data that can be used by the page.
   *
   * @returns {Object} The view-model data.
   */
  data() {
    return {
      drawer: null,
      vMenu: false,
      menuCollapsed: false,
      fullscreen: false,
      cookiePolicyDialog: false,
      aboutDialog: false,
      privacyPolicyDialog: false,
      unitListDialog: false,
      contactsDialog: false,
      unitListRoutePresent: this.$store.state.project.project.pages.some(({ route }) => route === ROUTE_UNIT_LIST),
      openedDialogFilterMobile: false,
      openedDialogFavouritesDesktop: false,
      openedDialogFavouritesMobile: false,
      pagesDefault: [
        {
          _id: 25,
          label: 'Overview',
          route: 'overview',
        },
        {
          _id: 15,
          label: 'Photos',
          route: 'gallery',
        },
        {
          _id: 486,
          label: 'Panoramas',
          route: 'panoramas',
        },
        {
          _id: 68,
          label: 'Location',
          route: 'area',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('project', [
      'pages',
      'projectLogo',
      'agents',
      'brokerCompany',
      'contactsModules',
      'i18nTranslations',
      'project',
      'settings',
      'contactFormEnabledOnContactPage',
      'statusSwitch',
    ]),
    ...mapGetters('service', ['fullscreenEnabled', 'topmenu']),
    ...mapGetters('units', ['favourites']),
    ...mapGetters({
      getLocalStorageItem: 'localStorage/getItem',
    }),
    ...mapGetters('exteriors', ['isShowTogglePOI', 'isPoiMaskOn']),
    contactAvailable() {
      return !this.disableContact
        && (this.pages || this.pagesDefault).some(({ route }) => route === 'contact');
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    menuOptions() {
      return this.filterPages(this.mobile ? PAGE_EXCLUSIONS.mobile : PAGE_EXCLUSIONS.desktop);
    },
    readyPages() {
      return this.filterPages(PAGE_EXCLUSIONS.desktop);
    },
    dropdownMenuState() {
      return {
        overlay: typeof this.toggleOverlayStatus === 'function',
        favourites: this.favourites.length > 0,
        unitlist: !this.unitListRoutePresent,
        fullscreen: this.fullscreenEnabled,
      };
    },
    dropdownMenuFulfilled() {
      return Object.values(this.dropdownMenuState)
        .filter(v => v).length;
    },
    haseHomePage() {
      return (this.pages || this.pagesDefault).find(page => page.route === 'home');
    },
    appBarHeight() {
      return this.topmenu ? APP_BAR_HEIGHT : 0;
    },
    cssVars() {
      return {
        '--app-bar-height': `${this.appBarHeight}px`,
        '--app-main-height': 'calc(100vh - var(--app-bar-height))',
        '--app-main-padding': '15px',
        '--app-main-top': 'calc(var(--app-bar-height) + var(--app-main-padding))',
        ...(this.settings.profile_color1 && { '--profile-color-1': this.settings.profile_color1 }),
        ...(this.settings.profile_color2 && { '--profile-color-2': this.settings.profile_color2 }),
      };
    },
  },
  watch: {
    $route: {
      handler(to) {
        const name = to && to.name;
        const hidePoiRoutes = new Set([
          'order.unit.view',
          'order.native-panorama.view',
          'order.panorama.unit-view',
        ]);
        if (hidePoiRoutes.has(name)) {
          this.$store.dispatch('exteriors/isShownTogglePOI', false);
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    this.fullscreen = this.$fullscreen.getState();
  },
  mounted() {
    const data = this.getLocalStorageItem(`${ADD_FAVOURITE}_${this.$route.params.order}`);
    const favouritesList = data && JSON.parse(data);

    if (Array.isArray(favouritesList)) {
      this.$store.dispatch('units/setFavourites', { units: favouritesList });
    }
  },
  methods: {
    shouldBeActive(page) {
      const { prevRoute } = this.$store.state.navigation;
      if (page.label === 'page_unit-list') {
        return prevRoute && prevRoute === 'order.unit-list' && this.isUnitsDeepLink()
      }
      if (page.label === 'page_overview') {
        return prevRoute !== 'order.unit-list' && this.isUnitsDeepLink();
      }
      return false
    },
    isUnitsDeepLink() {
      const route = this.$route.name
      return route === 'order.unit.view' ||
             route === 'order.native-panorama.view' ||
             route === 'order.panorama.unit-view'
    },
    toggleFullscreen() {
      this.$fullscreen.toggle(document.documentElement, {
        wrap: false,
        callback: this.fullscreenChange,
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    togglePoiMaskStatus() {
      this.$store.dispatch('exteriors/togglePoiMask', !this.isPoiMaskOn);
    },
    openExternalLink(link) {
      if (link) {
        window.open(link, 'blank');
      }
    },
    switchAnalytics(value) {
      this.$store.dispatch('service/setOptOut', value);

      if (value) {
        Vue.$ga.enable();
        Vue.$gtm.enable(true);
      } else {
        Vue.$ga.disable();
        Vue.$gtm.enable(false);
      }
    },
    getCdn(source) {
      return cdnUrl(source);
    },
    filterPages(exclusions) {
      const pages = this.pages && this.pages.length
        ? this.pages
        : this.pagesDefault;

      return pages.filter(({ route }) =>
        route &&
        !exclusions.includes(route));
    },
  },
};
</script>
<style scoped>
.v-toolbar a, .v-toolbar a:hover {
  text-decoration: none;
  color: initial;
}

.logo {
  max-height: 100%;
  max-width: 100%;
}

.v-btn {
  text-transform: initial;
}

.morevert__menu-item {
  text-transform: capitalize;
}
.custom-navigation-highlight {
  border-bottom: var(--primary-color) 2px solid;
}
@media only screen and (max-width: 959px) {
  .custom-navigation-highlight {
    border: none;
    font-weight: bold;
    background-color: #eeeeee;
  }
}
</style>
<style lang="scss">
@supports (-webkit-touch-callout: none) {
  main.v-content.overlay-open  {
    padding-top: 0 !important;
    z-index: 9999 !important;

    .viewport-container{
      z-index:100;
    }
  }
}

.v-app-bar {
  color: var(--header-color, #616161) !important;
  caret-color: var(--header-color, #616161) !important;
  background-color: var(--header-background-color, #fafafa) !important;
  border-color: var(--header-background-color, #fafafa) !important;
}

.navigator-tabs .v-tabs__container {
  height: 56px;
}

.navigator-tab-item {
  color: #646464;
  height: 56px;
  vertical-align: middle;
  padding-left: 25px;
  padding-right: 25px;
  text-transform: uppercase;
}

.navigator-tab-item a {
  padding-left: 30px;
  padding-right: 30px;
}

.router-link-active {
  border-bottom: var(--primary-color) 2px solid;
}
@media only screen and (max-width: 959px) {
  .router-link-active {
    border: none;
    font-weight: bold;
    background-color: #eeeeee;
  }
}
.homeInactive {
  border-bottom: none;
}
.v-toolbar .v-badge .v-badge__badge {
  font-size: 0.75em;
  top: -6px;
  right: -9px;
  height: 18px;
  width: 18px;
  border-radius: 9px;
}

.toggle-contacts-dialog {
  position: fixed;
  z-index: 20;

  bottom: var(--app-main-padding);
  right: var(--app-main-padding);
  border-radius: 28px;
  width: 56px;
  height: 56px;
  transition: transform 0.3s ease;

  @media (max-width: 1500px), (max-height: 920px) {
    transform: scale(0.85);
    margin-bottom: -8px;
  }
}

.about-dialog .dialog-link {
  /*margin-right: 24px;*/
  margin-bottom: 24px;
  display: block;
}

@media screen and (max-width: 960px) {
  .toggle-contacts-dialog {
    bottom: 130px;
  }
}

.v-menu__content .v-list .v-badge .v-badge__badge {
  top: -9px;
  right: -12px;
}
</style>
<style lang="scss">
.v-navigation-drawer {
  height: 100vh !important;
  position: fixed;
  left: -1px !important;

  .inner_drawer {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    height: 100%;
    padding-bottom: 16px;
    transition: 300ms;

    .project_name {
      text-transform: uppercase;
    }
  }

  .v-toolbar__content {
    height: auto !important;
    text-align: left;
    padding: 16px;
    padding-top: 30px;
    transition: padding 300ms;
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: calc(env(safe-area-inset-left) + 16px);
    }

    img {
      max-width: 100%;
      margin-bottom: 17px;
    }
  }

  .v-list__tile {
    cursor: pointer;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: calc(env(safe-area-inset-left) + 16px);
    }
  }

  .v-list {
    text-transform: uppercase;
  }

  .trademark {
    padding: 0 16px;
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: calc(env(safe-area-inset-left) + 16px);
    }
    @media screen and (orientation: portrait) and (max-width: 960px) {
      @supports (padding-bottom: env(safe-area-inset-bottom)) {
        padding-bottom: env(safe-area-inset-bottom);
      }
    }

    .product_name {
      font-size: 1em;
      margin-bottom: 3px;
    }

    .pow_by {
      font-size: 0.81em;
    }

    p {
      margin-bottom: 0;
    }

    img {
      max-height: 30px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
    }
  }
}

.v-content.grid > * {
  display: grid;
}
.v-btn__content {
  img {
    height: 56px;
    width: 56px;
  }
}
</style>
